import { render, staticRenderFns } from "./projectcategory.vue?vue&type=template&id=2effb230&scoped=true&"
import script from "./projectcategory.vue?vue&type=script&lang=js&"
export * from "./projectcategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2effb230",
  null
  
)

export default component.exports